/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * IN operator looks for values that are in the given list of values.
 */
export interface InUri {
    /** The values to compare against. */
    values: string[];
}
